import defaultClient from '@/plugins/axios/defaultClient'

export default {
  /**
   *
   * @param {
   * {
   *   "provider": "cafe24",
   *   "adminId": "admin",
   *   "adminPassword": "admin1234"
   * }
   * } mall
   * @returns
   */
  postMalls(mall) {
    return defaultClient.post('/malls', mall)
  },
  putMalls(mall) {
    return defaultClient.put(`/malls/${mall.uuid}`, mall)
  },
  getMallsDetail({ uuid }) {
    return defaultClient.get(`/malls/${uuid}`)
  },
  getMalls() {
    return defaultClient.get('/malls')
  },
  getMallProviders() {
    return defaultClient.get('/mall-providers')
  },
}
